import { DecagramIcon } from './DecagramIcon';

/**
 * author: Austin Andrews
 * id DA734DBD-1239-4E30-B688-ADF6A9D222D0
 * name decagram
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/decagram.svg
 * tags
 * - Shape 
 */
export const StarburstIcon = DecagramIcon;
export default StarburstIcon